import { render, staticRenderFns } from "./reportTable.vue?vue&type=template&id=3613a85c&scoped=true"
import script from "./reportTable.vue?vue&type=script&lang=js"
export * from "./reportTable.vue?vue&type=script&lang=js"
import style0 from "./reportTable.vue?vue&type=style&index=0&id=3613a85c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3613a85c",
  null
  
)

export default component.exports